import { render, staticRenderFns } from "./NewPrimarySchool.vue?vue&type=template&id=b6e8d8f8&scoped=true&"
import script from "./NewPrimarySchool.vue?vue&type=script&lang=js&"
export * from "./NewPrimarySchool.vue?vue&type=script&lang=js&"
import style0 from "./NewPrimarySchool.vue?vue&type=style&index=0&id=b6e8d8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e8d8f8",
  null
  
)

export default component.exports